import { render, staticRenderFns } from "./trolleyDrawer.vue?vue&type=template&id=7960b168&scoped=true"
import script from "./trolleyDrawer.vue?vue&type=script&lang=js"
export * from "./trolleyDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960b168",
  null
  
)

export default component.exports